import { Container, Row, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";

function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="py-4">
      <Container fluid="lg">
        <Row className="g-3">
          <Col md={4}>
            <div className="d-flex align-items-center gap-2 mb-2">
              <img src="/favicon.svg" alt="Favluv" width={28} height={28} />
              <span className="fw-bold fs-16">Favluv</span>
            </div>
            <p className="mb-0">
              &copy; 2024–2025 Favluv by Wishcan Inc. <br />
              {t("rights_reserved")}
            </p>
          </Col>
          <Col md={4} className="d-flex flex-column gap-1">
            <p className="mb-1 fw-bold fs-16">{t("footer_legal")}</p>
            <a href="/rules" target="_blank" rel="noopener noreferrer">{t("favluv_rules")}</a>
            <a href="/terms" target="_blank" rel="noopener noreferrer">{t("terms_and_conditions")}</a>
            <a href="/privacy" target="_blank" rel="noopener noreferrer">{t("privacy_policy")}</a>
            <a href="/cookies" target="_blank" rel="noopener noreferrer">{t("cookie_policy")}</a>
          </Col>
          <Col md={4} className="d-flex flex-column gap-1">
            <p className="mb-1 fw-bold fs-16">{t("footer_support")}</p>
            <a href="/api-docs" target="_blank" rel="noopener noreferrer">{t("api_documentation")}</a>
            <a href="/chat-token" target="_blank" rel="noopener noreferrer">{t("chatbot_setup_guide")}</a>
            <a href="https://docs.google.com/forms/d/e/1FAIpQLScxPi-1g35gr0U7QUeMr2HqIWQB_FMK5MlrJ9rhWneSvn2Mog/viewform?usp=sharing&ouid=106922785454417437063" target="_blank" rel="noopener noreferrer">{t("bug_report")}</a>
            <a href="/contact" target="_blank" rel="noopener noreferrer">{t("contact_us")}</a>
          </Col>
        </Row>
      </Container>
    </footer>
  );
}

export default Footer;
